import { CallTranscript, Customer, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'call_transcript_id';
export interface TranscriptSearchParams
  extends SearchParams<Filter, Sort>,
    Partial<CallTranscript> {
  customer_id?: ModelID;
}

export const featurePath = (customer: Customer) =>
  `/v4/customers/customer/${customer.id}/transcript`;

export const featureKeys = {
  all: [{ scope: 'transcripts' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: TranscriptSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
